import React from "react";
import { withRouter } from "react-router-dom";
import Button from "../components/buttons/Button";

export default withRouter(
  ({ history, actionLabel = "Ajouter", actionLink }) => {
    return (
      <div className="oEditBar">
        <Button
          outlined
          icon="pencil"
          rounded
          onClick={() => history.push("/settings")}
        >
          Edit my profile
        </Button>
        <Button icon="plus" rounded onClick={() => history.push(actionLink)}>
          {actionLabel}
        </Button>
      </div>
    );
  }
);
